<template>
  <div class="page">
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10,50, 100, 200, 300]"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['total'],
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    }
  },
  methods: {
    // pageSize页面改变触发
    handleSizeChange(val) {
      this.$emit('chileByPageSize', val)
      this.$nextTick(function() {
        this.$parent.getListData()
      })
    },
    // 当前页改变触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('chileByCurrentPage', val)
      this.$nextTick(function() {
        this.$parent.getListData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 20px 0 10px 0;
  text-align: right;
  color: #585858;
  ::v-deep .el-pagination{
    padding: 0 20px 0 20px;
  }
  ::v-deep .btn-prev {
    border: 1px solid #bcbcbc;
    background-color: transparent;
    margin-right: 4px;
     &:hover {
        border: 1px solid #0e8ce5;
      }
  }
  ::v-deep .btn-next {
    border: 1px solid #bcbcbc;
    background-color: transparent;
      &:hover {
        border: 1px solid #0e8ce5;
      }
  }
  ::v-deep .el-pager {
    li {
      width: 29px;
      height: 29px;
      border-radius: 2px;
      border: 1px solid #bcbcbc;
      margin-right: 4px;
      color: #585858;
      background-color: transparent;
    }
    .active {
      width: 29px;
      height: 29px;
      border-radius: 2px;
      border: 1px solid #0e8ce5;
      color: #0E8CE5;
    }
  }
}
</style>
